export function calculateFinancialRatios(data: any[]) {
  return data.map((yearData, index) => {
    const { bs, pnl, year } = yearData;
    const netRevenue = pnl?.lineItems?.net_revenue ?? 0;
    const cogs = (pnl?.lineItems?.total_cost_of_materials_consumed ?? 0) + (pnl?.lineItems.total_changes_in_inventories_or_finished_goods ?? 0 )+ (pnl?.lineItems.total_purchases_of_stock_in_trade ?? 0)
    const employeeBenefitExpenses = pnl?.lineItems.total_employee_benefit_expense ?? 0;
    const otherExpenses = pnl?.lineItems.total_other_expenses ?? 0;
    const ebitda = (pnl?.lineItems.profit_before_interest_and_tax ? pnl?.lineItems.profit_before_interest_and_tax : 0 ) + (pnl?.lineItems.depreciation ? pnl?.lineItems.depreciation : 0) + (pnl?.lineItems.interest ?? 0)+(pnl.lineItems.income_tax ?? 0);
    const financeCost = pnl?.lineItems.interest ?? 0;
    const depreciation = pnl?.lineItems.depreciation ?? 0 ;
    const pat = pnl?.lineItems.profit_after_tax ?? 0  ;

    const tangibleAssets = bs?.assets.tangible_assets ?? 0 ;
    const intangibleAssets = bs?.assets.intangible_assets ?? 0 + (bs?.assets.intangible_assets_under_development ? bs?.assets.intangible_assets_under_development : 0);
    const capitalWIP = bs?.assets.tangible_assets_capital_work_in_progress ?? 0 ;


                


    const nonCurrentAssetsExclFixed = (bs.assets.tangible_assets+ bs.assets.producing_properties+bs.assets.intangible_assets+bs.assets.preproducing_properties+bs.assets.tangible_assets_capital_work_in_progress+bs.assets.intangible_assets_under_development+bs.assets.noncurrent_investments+bs.assets.deferred_tax_assets_net+bs.assets.foreign_curr_monetary_item_trans_diff_asset_account+bs.assets.long_term_loans_and_advances+bs.assets.other_noncurrent_assets);

    const tangibleNetWorth = bs.liabilities.share_capital + bs.liabilities.reserves_and_surplus + bs.liabilities.money_received_against_share_warrants + bs.liabilities.share_application_money_pending_allotment + bs.liabilities.deferred_government_grants + bs.liabilities.minority_interest ;
    const quasiEquity = 0;
    // const adjustedTangibleNetWorth = tangibleNetWorth + quasiEquity;
 

    const total_non_current_liabilities = bs.liabilities.long_term_borrowings + bs.liabilities.deferred_tax_liabilities_net + bs.liabilities.foreign_curr_monetary_item_trans_diff_liability_account + bs.liabilities.other_long_term_liabilities + bs.liabilities.long_term_provisions;

    const total_current_liabilities = bs.liabilities.short_term_borrowings + bs.liabilities.trade_payables + bs.liabilities.other_current_liabilities + bs.liabilities.short_term_provisions

    const totalOutsideLiabilities = total_non_current_liabilities + total_current_liabilities;
    const longTermDebt = bs?.liabilities.long_term_borrowings ?? 0 ;
    const shortTermDebt = bs?.liabilities.short_term_borrowings ?? 0 ;
    const totalDebt =longTermDebt +  shortTermDebt;

    const currentAssets = (bs?.assets?.current_investments ?? 0) + (bs?.assets?.inventories ?? 0) + (bs?.assets?.trade_receivables ?? 0) + (bs?.assets?.cash_and_bank_balances ?? 0) + (bs?.assets?.short_term_loans_and_advances ?? 0) + (bs?.assets?.other_current_assets ?? 0);

  
    const currentLiabilities = bs?.liabilities.short_term_borrowings + bs?.liabilities.trade_payables + bs?.liabilities.other_current_liabilities + bs?.liabilities.short_term_provisions;

    const currentRatio = currentAssets / currentLiabilities;
    const netWorkingCapital = currentAssets - currentLiabilities;

    const inventories = bs?.assets.inventories ?? 0;;
    const tradeReceivables = bs?.assets.trade_receivables ?? 0;;
    const tradePayables = bs?.liabilities.trade_payables ?? 0;;
    const cashAndCashEquivalents = bs?.assets.cash_and_bank_balances ?? 0 ;

    const inventoriesHoldingPeriod = (inventories / Math.abs(cogs)) * 365;
    const debtorsHoldingPeriod = (tradeReceivables / netRevenue) * 365;
    const creditorsHoldingPeriod = (tradePayables / Math.abs(cogs)) * 365;

    
    const dscr = ebitda / financeCost;

    let revenueGrowth = 0;
    if (index > 0) {
      const previousRevenue = data[index - 1].pnl.lineItems.net_revenue;
      revenueGrowth = ((netRevenue - previousRevenue) / previousRevenue) * 100;
    }
    const subTotals = (bs.liabilities.share_capital +bs.liabilities.reserves_and_surplus +bs.liabilities.money_received_against_share_warrants +bs.liabilities.share_application_money_pending_allotment +bs.liabilities.deferred_government_grants - bs.liabilities.minority_interest ) - (bs.assets.intangible_assets + bs.assets.intangible_assets_under_development)
    const debtEquityRatio = totalDebt / subTotals;
    return {
        year: year,
        netRevenue: netRevenue / 10000000, // Convert to crores (10 million)
        revenueGrowth: revenueGrowth,
        otherIncome: (pnl?.lineItems.other_income ?? 0) / 10000000,
        cogs: cogs / 10000000,
        employeeBenefitExpenses: employeeBenefitExpenses / 10000000,
        otherExpenses: otherExpenses / 10000000,
        ebitda: ebitda / 10000000,
        ebitdaPercent: (ebitda / netRevenue) * 100,
        financeCost: financeCost / 10000000,
        depreciation: depreciation / 10000000,
        pat: pat / 10000000,
        patPercent: (pat / netRevenue) * 100,
        tangibleAssets: tangibleAssets / 10000000,
        intangibleAssets: intangibleAssets / 10000000,
        capitalWIP: capitalWIP / 10000000,
        nonCurrentAssetsExclFixed: nonCurrentAssetsExclFixed / 10000000,
        // tangibleNetWorth: tangibleNetWorth / 10000000,
        tangibleNetWorth: subTotals / 10000000,

        quasiEquity: quasiEquity / 10000000,
        // adjustedTangibleNetWorth: adjustedTangibleNetWorth / 10000000,

        totalOutsideLiabilities: totalOutsideLiabilities / 10000000,
        tolTnwRatio: totalOutsideLiabilities / subTotals,
        // tolAtnwRatio: totalOutsideLiabilities / adjustedTangibleNetWorth,
        longTermDebt: longTermDebt / 10000000,
        shortTermDebt: shortTermDebt / 10000000,
        totalDebt: totalDebt / 10000000,
        currentAssets: currentAssets / 10000000,
        currentLiabilities: currentLiabilities / 10000000,
        currentRatio: currentRatio,
        netWorkingCapital: netWorkingCapital / 10000000,
        inventories: inventories / 10000000,
        tradeReceivables: tradeReceivables / 10000000,
        tradePayables: tradePayables / 10000000,
        cashAndCashEquivalents: cashAndCashEquivalents / 10000000,
        inventoriesHoldingPeriod: inventoriesHoldingPeriod,
        debtorsHoldingPeriod: debtorsHoldingPeriod,
        creditorsHoldingPeriod: creditorsHoldingPeriod,
        // drawingPower: (inventories * 0.75 + tradeReceivables * 0.80) / 10000000, // Example calculation
        drawingPower: ((inventories  + tradeReceivables - tradePayables ) * 0.75) / 10000000, // Example calculation

        debtEquityRatio: debtEquityRatio,
        dscr: dscr
    };
  });
}

export function calculateLLPFinancialRatios(data: any[]) {
  return data.map((yearData, index) => {
    const { year, statement_of_assets_and_liabilities, statement_of_income_and_expenditure } = yearData;
    
    // Use correct property names
    const bs = statement_of_assets_and_liabilities;
    const pnl = statement_of_income_and_expenditure;
    
    // P&L Items
    const netRevenue = pnl?.lineItems?.net_revenue ?? 0;
    const cogs = (pnl?.lineItems?.total_cost_of_materials_consumed ?? 0) + 
                 (pnl?.lineItems?.total_purchases_of_stock_in_trade ?? 0) + 
                 (pnl?.lineItems?.total_changes_in_inventories_or_finished_goods ?? 0);
    const employeeBenefitExpenses = pnl?.lineItems?.total_employee_benefit_expense ?? 0;
    const otherExpenses = pnl?.lineItems?.total_other_expenses ?? 0;
    const operatingProfit = pnl?.lineItems?.operating_profit ?? 0;
    const depreciation = pnl?.lineItems?.depreciation ?? 0;
    const ebitda = operatingProfit + depreciation;
    const financeCost = pnl?.lineItems?.interest ?? 0;
    const pat = pnl?.lineItems?.profit_after_tax ?? 0;
    const otherIncome = pnl?.lineItems?.other_income ?? 0;

    // Balance Sheet - Assets
    const netFixedAssets = bs?.assets?.net_fixed_assets ?? 0;
    const grossFixedAssets = bs?.assets?.gross_fixed_assets ?? 0;
    const investments = bs?.assets?.investments ?? 0;
    const loansAndAdvances = bs?.assets?.loans_and_advances ?? 0;
    const inventories = bs?.assets?.inventories ?? 0;
    const tradeReceivables = bs?.assets?.trade_receivables ?? 0;
    const cashAndCashEquivalents = bs?.assets?.cash_and_cash_equivalents ?? 0;
    const otherAssets = bs?.assets?.other_assets ?? 0;

    // Balance Sheet - Liabilities
    const contributionReceived = bs?.liabilities?.contribution_received ?? 0;
    const reservesAndSurplus = bs?.liabilities?.reserves_and_surplus ?? 0;
    const securedLoan = bs?.liabilities?.secured_loan ?? 0;
    const unsecuredLoan = bs?.liabilities?.unsecured_loan ?? 0;
    const shortTermBorrowing = bs?.liabilities?.short_term_borrowing ?? 0;
    const tradePayables = bs?.liabilities?.trade_payables ?? 0;
    const otherLiabilities = bs?.liabilities?.other_liabilities ?? 0;
    const provisionsForTaxation = bs?.liabilities?.provisions_for_taxation ?? 0;
    const provisionsForContingencies = bs?.liabilities?.provisions_for_contingencies ?? 0;
    const provisionsForInsurance = bs?.liabilities?.provisions_for_insurance ?? 0;
    const otherProvisions = bs?.liabilities?.other_provisions ?? 0;

    // Calculated Values
    const tangibleNetWorth = contributionReceived + reservesAndSurplus;
    
    const longTermDebt = securedLoan + unsecuredLoan;
    const shortTermDebt = shortTermBorrowing;
    const totalDebt = longTermDebt + shortTermDebt;

    const currentAssets = inventories + tradeReceivables + cashAndCashEquivalents + otherAssets;
    
    const currentLiabilities = shortTermBorrowing + tradePayables + otherLiabilities + 
                               provisionsForTaxation + provisionsForContingencies + 
                               provisionsForInsurance + otherProvisions;

    const totalOutsideLiabilities = longTermDebt + currentLiabilities;

    const currentRatio = currentLiabilities !== 0 ? currentAssets / currentLiabilities : 0;
    const netWorkingCapital = currentAssets - currentLiabilities;

    const nonCurrentAssetsExclFixed = investments + loansAndAdvances;

    // Working Capital Ratios
    const inventoriesHoldingPeriod = Math.abs(cogs) !== 0 ? (inventories / Math.abs(cogs)) * 365 : 0;
    const debtorsHoldingPeriod = netRevenue !== 0 ? (tradeReceivables / netRevenue) * 365 : 0;
    const creditorsHoldingPeriod = Math.abs(cogs) !== 0 ? (tradePayables / Math.abs(cogs)) * 365 : 0;

    // Financial Ratios
    const dscr = shortTermDebt !== 0 ? ebitda / shortTermDebt : 0;
    const debtEquityRatio = tangibleNetWorth !== 0 ? totalDebt / tangibleNetWorth : 0;

    // Revenue Growth
    let revenueGrowth = 0;
    if (index > 0 && data[index - 1]?.statement_of_income_and_expenditure?.lineItems?.net_revenue) {
      const previousRevenue = data[index - 1].statement_of_income_and_expenditure.lineItems.net_revenue;
      if (previousRevenue !== 0) {
        revenueGrowth = ((netRevenue - previousRevenue) / previousRevenue) * 100;
      }
    }

    // Drawing Power Calculation (Inventories + Receivables - Payables) * 75%
    const drawingPower = ((inventories + tradeReceivables - tradePayables) * 0.75) / 10000000;

    return {
      year: year,
      netRevenue: netRevenue / 10000000, // Convert to crores
      revenueGrowth: revenueGrowth,
      otherIncome: otherIncome / 10000000,
      cogs: cogs / 10000000,
      employeeBenefitExpenses: employeeBenefitExpenses / 10000000,
      otherExpenses: otherExpenses / 10000000,
      ebitda: ebitda / 10000000,
      ebitdaPercent: netRevenue !== 0 ? (ebitda / netRevenue) * 100 : 0,
      financeCost: financeCost / 10000000,
      depreciation: depreciation / 10000000,
      pat: pat / 10000000,
      patPercent: netRevenue !== 0 ? (pat / netRevenue) * 100 : 0,
      
      // Assets
      netFixedAssets: netFixedAssets / 10000000,
      grossFixedAssets: grossFixedAssets / 10000000,
      investments: investments / 10000000,
      nonCurrentAssetsExclFixed: nonCurrentAssetsExclFixed / 10000000,
      
      // Capital Structure
      tangibleNetWorth: tangibleNetWorth / 10000000,
      contributionReceived: contributionReceived / 10000000,
      reservesAndSurplus: reservesAndSurplus / 10000000,
      
      // Liabilities
      totalOutsideLiabilities: totalOutsideLiabilities / 10000000,
      tolTnwRatio: tangibleNetWorth !== 0 ? totalOutsideLiabilities / tangibleNetWorth : 0,
      longTermDebt: longTermDebt / 10000000,
      shortTermDebt: shortTermDebt / 10000000,
      totalDebt: totalDebt / 10000000,
      
      // Working Capital
      currentAssets: currentAssets / 10000000,
      currentLiabilities: currentLiabilities / 10000000,
      currentRatio: currentRatio,
      netWorkingCapital: netWorkingCapital / 10000000,
      inventories: inventories / 10000000,
      tradeReceivables: tradeReceivables / 10000000,
      tradePayables: tradePayables / 10000000,
      cashAndCashEquivalents: cashAndCashEquivalents / 10000000,
      
      // Days Ratios
      inventoriesHoldingPeriod: inventoriesHoldingPeriod,
      debtorsHoldingPeriod: debtorsHoldingPeriod,
      creditorsHoldingPeriod: creditorsHoldingPeriod,
      
      // Other Ratios
      drawingPower: drawingPower,
      debtEquityRatio: debtEquityRatio,
      dscr: dscr
    };
  });
}

// Usage example:
// const llpRatios = calculateLLPFinancialRatios(llpData);


  
